import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { NavbarCode } from '@/components/CodeView/NavbarCode';
import { SourceCode } from '@/components/SourceCode';
import { searchParam } from '@/utils/router';

const codeViewSchema = z.object({
  branchId: searchParam().optional(),
  versionId: searchParam().optional(),
});

export const Route = createFileRoute('/$organizationName/cb/$codebaseId/code/$')({
  component: CodeViewPage,
  validateSearch: zodValidator(codeViewSchema),
});

function CodeViewPage() {
  const { _splat } = Route.useParams();

  return (
    <div className="flex h-screen w-full flex-col">
      <NavbarCode />
      <div className="grow overflow-auto">
        <SourceCode path={_splat} />
      </div>
    </div>
  );
}
